import {addDays} from "date-fns";
import {CalculateTotalMinutes} from './TimeFunctions';
// Add the timecode to the existing set of timecodes. This involves adding necessary clients,projects, budgets and timecodes as needed.
// finally addng the empty entrydays. 
export const AddNewTimecode = (weekStart, data, client, project, budget, timecode, userDetails, existingTimecode, lockedMonths)=>{
    var targetClient=null;
    for(var clientIndex=0; clientIndex < data.length; clientIndex++){
      if(data[clientIndex].clientId === client.clientId) targetClient = data[clientIndex];
    }

    if(targetClient===null){
      targetClient= {clientId: client.clientId, clientName: client.clientName, projects:[]};
      data=[...data, targetClient];
  }

  var targetProject=null;
  for(var projectIndex=0; projectIndex < targetClient.projects.length; projectIndex++){
    if(targetClient.projects[projectIndex].projectId === project.projectId) targetProject = targetClient.projects[projectIndex];    
  }


  if(targetProject===null){
      targetProject= {projectId: project.projectId, projectName: project.projectName, projectStartDate: project.projectStart, projectEndDate: project.projectEnd, budgets:[]};
      targetClient.projects=[...targetClient.projects,targetProject];
  }

  var targetBudget=null;
  for(var budgetIndex=0; budgetIndex < targetProject.budgets.length; budgetIndex++){
    if(targetProject.budgets[budgetIndex].budgetId === budget.budgetId) targetBudget =targetProject.budgets[budgetIndex];
  }

  if(targetBudget===null){
    targetBudget= {budgetId: budget.budgetId, budgetName: budget.budgetName, timecodes:[]};
    targetProject.budgets=[...targetProject.budgets, targetBudget];
  }
  const isDuplicate = targetBudget.timecodes.some(q => 
    q.taskId === timecode.taskId &&
    q.entryDays.some(entry => entry.date.toString() === weekStart.toString())
  );

  if (isDuplicate) {
    throw Error("Attempted to add duplicate timecode for this week");
  }

  var instance = {
    userStartDate: userDetails.userStartDate,
    userEndDate: userDetails.userEndDate,
    taskId: timecode.taskId, 
    taskName: timecode.taskName, 
    taskStartDate: timecode.taskStartDate,
    taskEndDate: timecode.taskEndDate,
    budgetId: targetBudget.budgetId,
    projectId: targetProject.projectId,
    projectName: targetProject.projectName,
    projectStartDate: targetProject.projectStartDate,
    projectEndDate: targetProject.projectEndDate,
    clientId: targetClient.clientId,
    entryDays: []
  };
  if (existingTimecode) targetBudget.timecodes=[...targetBudget.timecodes, inflateExistingEntryRow(weekStart, existingTimecode, lockedMonths)];
  else targetBudget.timecodes=[...targetBudget.timecodes, inflateTimecodeEntryRow(weekStart, instance, lockedMonths)];

  return data;
}

export const inflateExistingEntryRow = (weekStart, row, lockedMonths) => {
  const projectStart = new Date(row.projectStart);
  const projectEnd = new Date(row.projectEnd);
  const timecodeStart = new Date(row.taskStart);
  const timecodeEnd = new Date(row.taskEnd);

  let entrydays = [];
  row.entryDays = entrydays;
  
  // Loop through each day in the week (7 days) and check if a time entry exists for it
  for (let i = 0; i < 7; i++) {
    let date = addDays(weekStart, i);
    const currentMonth = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
    const isMonthLocked = lockedMonths?.has(currentMonth); 
    // This will be true if ANY timecode had a locked entry in this month
    
    let target = row.timeEntries.find(q => new Date(q.date).toISOString() === date.toISOString());
    let status = "error";
    if (!target) {
      switch (true) {
        case (date > projectEnd || date < projectStart):
          status = "outOfProjectRange";
          break;
        case (date > timecodeEnd || date < timecodeStart):
          status = "outOfTimecodeRange";
          break;
        default:
          status = "empty"; 
          break;
      }
      target = {
        date: date,
        status: status,
        totalMinutes: 0,
        entries: [],
        isReviewed: false,
        casualMonthLocked: isMonthLocked,
        isInvoiced: false,
      };
    } else {
      // Disable row for add timecode selector
      row.isDisabled = true;

      // Set metadata for existing entries
      let entryDayEntries = target.timeEntryDetails;
      let totalMinutes = 0;
      entryDayEntries.forEach(entry => {
        entry.id = entry.timeEntryDetailId ;

        entry.totalMinutes = CalculateTotalMinutes(entry.start,entry.end,entry.break);
        totalMinutes += entry.totalMinutes;

        entry.startEndValidationState='none';
        entry.breakValidationState='none';
        entry.isValid=false;
        entry.isReviewed=target.isReviewed;
      });

      // total minutes check for existing PW data with no entry details
      if (totalMinutes === 0) {
        // If time entry exists, update the target with entry details
        target = {
          date: date,
          status: 'closed',
          totalMinutes: target.hours*60,
          entries: target.timeEntryDetails,
          isReviewed: false,
          casualMonthLocked: target.casualMonthLocked,
          isInvoiced: Boolean(target.invoiceId)
      };
      } else {
        // If time entry exists, update the target with entry details
        target = {
        date: date,
        status: 'open',
        totalMinutes: totalMinutes,
        entries: target.timeEntryDetails,
        isReviewed: target.isReviewed,
        casualMonthLocked: target.casualMonthLocked,
        isInvoiced: Boolean(target.invoiceId)
      };
      }
      
    }
    // Add the target entry for this day
    entrydays.push(target);
  }

  return row;
};


// Add entryDay records as needed to the row. this will fill in the blanks so every day in the week has at least a blank entry
export const inflateTimecodeEntryRow = (weekStart, row, lockedMonths) => {
  const projectStart = new Date(row.projectStartDate);
  const projectEnd = new Date(row.projectEndDate);
  const timecodeStart = new Date(row.taskStartDate);
  const timecodeEnd = new Date(row.taskEndDate);

  var entrydays = [];
  
  for(var i=0; i < 7; i++){    
    let date = addDays(weekStart, i);
    const currentMonth = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
    const isMonthLocked = lockedMonths?.has(currentMonth);

    var target = row.entryDays.find(q=> q.date === date);
    var status = "error";
    if (target===undefined){
      switch (true) {
        case (date > projectEnd || date < projectStart):
          status = "outOfProjectRange";
          break;
        case (date > timecodeEnd || date < timecodeStart):
          status = "outOfTimecodeRange";
          break;
        default:
          status = "empty";
          break;
      }
      target= {
        date:date,
        status:status,
        totalMinutes:0,
        entries:[],
        isReviewed: false,
        casualMonthLocked: isMonthLocked,
      };
    }
    entrydays.push(target)
  }
  var combinedEntryDays = row.entryDays.concat(entrydays);
  row.entryDays = combinedEntryDays;

  return row;
}

//figure out which timecodes are already used to stop users from adding duplicates
export const disableExistingTimecodes = (availableData, existingData, currentWeekStart) => {
  existingData.forEach(client => {
    const clientIndex = availableData.findIndex(q => q.clientId === client.clientId);
    if (clientIndex >= 0) {
      client.projects.forEach(project => {
        const projectIndex = availableData.findIndex(q => q.projectId === project.projectId);
        if (projectIndex >= 0) {
          project.budgets.forEach(budget => {
            const budgetIndex = availableData.findIndex(q => q.budgetId === budget.budgetId);
            if (budgetIndex >= 0) {
              budget.timecodes.forEach(timecode => {
                const timecodeIndex = availableData.findIndex(q => q.taskId === timecode.taskId);
                if (timecodeIndex >= 0) {
                  // Check if this timecode has an entry for the current week
                  const hasEntryForCurrentWeek = timecode.entryDays.some(entry => entry.date.toString() === currentWeekStart.toString());
                  // Disable the timecode if it has an entry for the current week
                  availableData[timecodeIndex].isDisabled = hasEntryForCurrentWeek;
                }
              });
            }
          });
        }
      });
    }
  });

  return availableData;
};

export const UpdateTimesheetLocalState =(existing, data, day)=>{
  
  var found= false;
  for(var clientIndex=0; clientIndex< existing.length;clientIndex++){
    if(existing[clientIndex].clientId===data.clientId){
      for(var projectIndex=0; projectIndex< existing[clientIndex].projects.length;projectIndex++){      
        if(existing[clientIndex].projects[projectIndex].projectId===data.projectId){
          for(var budgetIndex=0; budgetIndex< existing[clientIndex].projects[projectIndex].budgets.length;budgetIndex++){
            if(existing[clientIndex].projects[projectIndex].budgets[budgetIndex].budgetId===data.budgetId){
              for(var timecodeIndex=0; timecodeIndex< existing[clientIndex].projects[projectIndex].budgets[budgetIndex].timecodes.length;timecodeIndex++){
                if(existing[clientIndex].projects[projectIndex].budgets[budgetIndex].timecodes[timecodeIndex].taskId===data.taskId){
                  for(var dayIndex=0; dayIndex< existing[clientIndex].projects[projectIndex].budgets[budgetIndex].timecodes[timecodeIndex].entryDays.length; dayIndex++){
                    //update te view to avoid a re-render. By this stage the entry has been successfully saved
                    if(existing[clientIndex].projects[projectIndex].budgets[budgetIndex].timecodes[timecodeIndex].entryDays[dayIndex].date===day.date){
                      day.status="open";
                      day.totalMinutes =0;
                      
                      day.entries.forEach((item)=> {
                        day.totalMinutes += item.totalMinutes;
                      });
                      
                      if (day.totalMinutes === 0) day.status = "empty";

                      existing[clientIndex].projects[projectIndex].budgets[budgetIndex].timecodes[timecodeIndex].entryDays[dayIndex]= {...day};
                      found=true;
                      break;
                    }                    
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  
  if(!found){
    throw Error("Unable to find target timecode row");
  }

  return [...existing];
}

export const setTimesheetEntryStatus = (data, status) => {
        data.forEach(client => {
            client.projects.forEach(project => {
                project.budgets.forEach(budget => {
                    budget.timecodes.forEach(timecode => {
                        timecode.entryDays.forEach(day => {
                            if (day.isReviewed)
                                day.status = "approved";
                            else if (day.totalMinutes === 0) {
                              if (status === "rejected")
                                day.status = "empty";
                              else
                                day.status = "closed";
                            }
                                
                            else
                                day.status = status;
                        });
                    });
                });
            });
        });
}

export const getLockedMonths = (existingResources, currentLockedMonths) => {
  // Set so we dont need duplicates
  let lockedMonths = currentLockedMonths || new Set();
  // Goes through the timecodes/timeentries
  // Checks if any of them are monthly locked, if so add it to the month list
  // Could optimise with check for months in total first vs last

  // Set as global and use lock as global
  for(const resource of existingResources){
    for(const timeEntry of resource.timeEntries){
        if (timeEntry.casualMonthLocked && timeEntry.date) {
        const d = new Date(timeEntry.date);
        const formattedMonth = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
        
        lockedMonths.add(formattedMonth);
        }
    }
  }

  return lockedMonths;
}

export const updateTimeSheetData = async (data, currentWeekStart, lockedMonths) => {
  let casualSubmitLocked = false;
  let updatedTimesheetData = []

  data.forEach(resource => {
    if (resource.timeEntries.length > 0) {
      resource.timeEntries.forEach(entry => {
          if (entry.casualMonthLocked && new Date(entry.date) <= currentWeekStart) casualSubmitLocked = true;
        });
        // Add the resource info if it has existing entries for the week
        updatedTimesheetData = AddNewTimecode(
            currentWeekStart,
            updatedTimesheetData,
            {clientId :resource.clientId, clientName: resource.clientName},
            {projectId: resource.projectId, projectName: resource.projectName, projectStart: resource.projectStart, projectEnd: resource.projectEnd},
            {budgetId: resource.budgetId, budgetName: resource.budgetName},
            {taskId: resource.taskId, taskName: resource.taskName, taskStartDate: resource.taskStart, taskEndDate: resource.taskEnd},
            {userStartDate: resource.userMapping.userStart, userEndDate: resource.userMapping.userEnd},
            resource,
            lockedMonths
        );
    }

  });
  return {
    updatedData: updatedTimesheetData, 
    isLocked: casualSubmitLocked}
} 